import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { caseStudies } from "@/data/caseStudies";

interface Props {
  /** Exact case-study locations to show, e.g. ["Clifton, NJ"]. Omit to show all. */
  towns?: string[];
  heading?: string;
  intro?: string;
}

/** Real, documented case studies only — never relabel a project to another town. */
const RecentLocalProjects = ({ towns, heading = "Recent Local Projects", intro }: Props) => {
  const items = towns ? caseStudies.filter((c) => towns.includes(c.location)) : caseStudies;
  if (!items.length) return null;
  return (
    <section className="py-16 md:py-20 bg-muted/30 border-y border-border">
      <div className="container mx-auto px-4">
        <p className="text-xs uppercase tracking-[0.2em] text-primary mb-3">Real Projects</p>
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground mb-4">{heading}</h2>
        {intro && <p className="text-muted-foreground max-w-2xl mb-10">{intro}</p>}
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {items.map((c) => (
            <Link key={c.id} to={c.to} className="group bg-background border border-border overflow-hidden flex flex-col">
              <div className="aspect-[4/3] overflow-hidden bg-muted">
                <img src={c.src} alt={c.alt} loading="lazy" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
              </div>
              <div className="p-5 flex flex-col flex-1">
                <p className="text-xs uppercase tracking-wider text-muted-foreground mb-1">{c.location} · {c.service}</p>
                <h3 className="font-heading font-semibold text-lg text-foreground mb-2">{c.title}</h3>
                <p className="text-sm text-muted-foreground mb-4 flex-1">{c.blurb}</p>
                <span className="inline-flex items-center gap-2 text-sm font-medium text-primary">View Project <ArrowRight className="h-4 w-4" /></span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RecentLocalProjects;
